export default __webpack_public_path__ + "static/media/sch1_w320.c6d145ee.jpg";